import React from 'react';
import { GiEmptyHourglass } from 'react-icons/gi';
import { useSelector } from 'react-redux';
import { ModuleStatusListContainer } from './ModuleStatusList.css';
import StatusTable from './StatusTable';

const ModuleStatusList = () => {
  const gasLog = useSelector((store) => store.gasLog).gas;

  if (!gasLog) {
    return <ModuleStatusListContainer></ModuleStatusListContainer>;
  }

  if (gasLog.length === 0) {
    return (
      <ModuleStatusListContainer>
        <div className="module-empty">
          <GiEmptyHourglass />
          <span>현재 가동 중인 장치가 없습니다</span>
        </div>
      </ModuleStatusListContainer>
    );
  }

  return (
    <ModuleStatusListContainer>
      <div className="criterion-box">
        <table>
          <tbody>
            <tr className="criterion-name-tr">
              <td className="area-status-td">장치상태</td>
              <td className="area-name-td">위치번호</td>
              <td className="area-name-td">위치명</td>
              <td className="area-name-td">장치명</td>
              <td>
                CO<sub>2</sub>
              </td>
              <td>
                H<sub>2</sub>
              </td>
              <td>CO</td>
              <td>LEL</td>
              <td>rssi</td>
            </tr>
          </tbody>
        </table>
      </div>
      {gasLog.map((data) => {
        console.log('a\n', data);
        //const relayFlag = !data.fwVersion ? data.statusCode : data.relayFlag === 2 ? '1' : '0';
        return (
          <>
            {/* <AreaBox>{data.areaNm}</AreaBox> */}
            <StatusTable data={data} />
          </>
        );
      })}
    </ModuleStatusListContainer>
  );
};

export default ModuleStatusList;
